export default {"src":"__ASTRO_ASSET_IMAGE__yG$rqE5Z__","width":72,"height":72,"format":"svg"}